module.exports = "/images/collect-customer-information.svg?2613a9f8c4fdddb35e27995521206d4f";